<template>
    <div class="echart-container" id="echart-container" :style="innerStyle">
        <div :id="randomId" :style="innerStyle"></div>
    </div>
</template>

<script>
    const echarts = require('echarts/lib/echarts');
    // 引入折线图图组件
    require('echarts/lib/chart/line');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/pie');
    // 引入提示框和图例组件
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    export default {
        name: 'echart',
        props: {
            // echarts配置
            option: {
                required: false,
                default: () => {}
            },
            // 内部样式
            innerStyle: {
                required: false,
                default: () => {
                    return {
                        width: '900px',
                        height: '400px'
                    };
                }
            }
        },
        computed: {
            echartStyle () {
                return null;
            }
        },
        data () {
            return {
                // 生成不同的id,以防止冲突
                randomId: 'echart_' + (Math.random() * 100000000000000000),
                myEchart: null
            };
        },
        mounted () {
            this.init();
        },
        watch: {
            option: {
                handler (newValue) {
                    this.setOptions(newValue);
                },
                deep: true
            },
            innerStyle: {
                handler (newValue) {
                    this.$nextTick(() => {
                        this.myEchart.resize()
                    })
                },
                deep: true
            }
        },
        methods: {
            setOptions (options) {
                this.myEchart.setOption(options);
            },
            init () {
                // dom元素已经挂载上去了
                this.$nextTick(() => {
                    this.myEchart = echarts.init(document.getElementById(this.randomId));
                    this.myEchart.on('rendered', () => {
                        this.$on('rendered', this.myEchart);
                    });
                    this.myEchart.setOption(this.option);
                });
            }
        }
    };
</script>

<style lang="less">

</style>
